"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBannerVisibility = void 0;
var handleBannerVisibility = exports.handleBannerVisibility = function handleBannerVisibility(section, scrollPos, setVisibility) {
  if (section !== null && section !== void 0 && section.current && window !== undefined) {
    var _section$current;
    if (scrollPos > ((_section$current = section.current) === null || _section$current === void 0 ? void 0 : _section$current.offsetTop)) {
      setVisibility(true);
    } else {
      setVisibility(false);
    }
  }
};